import { Link, NavLink } from 'react-router-dom';
import './header.scss'

const Header = () => {
    return (
        <header className="header">
            <h1 className="logo">
                <Link to='/'>
                <span className="accent">Marvel</span> <span style={{color: '#000'}}>information portal</span>
                </Link>
            </h1>
            <div className="links">
                    {/* <NavLink className='header-links__link' end to="/" activeclassname="active">Characters</NavLink>/ 
                    <NavLink className='header-links__link' end to="/comics"activeclassname="active">Comics</NavLink> */}
                    <NavLink className='header-links__link' end to="/" style={({ isActive }) => ({color: isActive ? '#9F0013' : 'inherit'})}>Characters</NavLink>/ 
                    <NavLink className='header-links__link' to="/comics" style={({ isActive }) => ({color: isActive ? '#9F0013' : 'inherit'})}>Comics</NavLink>
            </div>
        </header>
    )
}

export default Header;